import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';

const HowItWorksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${cssThemedValue('borderPrimary')};
`;

const HowItWorksHeadingContainer = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  align-self: stretch;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
`;

const HowItWorksBodyContainer = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  align-self: stretch;
`;

export const HowItWorks = () => {
  return (
    <HowItWorksContainer>
      <HowItWorksHeadingContainer>
        <Typography.Heading6>
          <FormattedMessage id="best-of-wolt.how-it-works.title" />
        </Typography.Heading6>
      </HowItWorksHeadingContainer>
      <HowItWorksBodyContainer>
        <Typography.Body1>
          <FormattedMessage id="best-of-wolt.how-it-works.description" />
        </Typography.Body1>
      </HowItWorksBodyContainer>
    </HowItWorksContainer>
  );
};
